module.exports = __webpack_public_path__ + "img/2.55feef4d.jpg";